import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';
import Select from '../../Form/Field/Select.jsx';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';

import submit from './submit';
import mailing from './mailing';
export const name = 'MailingForm';

class MailingForm extends Component {
  constructor(props) {
    super(props);
    if (props.data) {
      props.initialize(props.data);
    }
  }

  render() {
    return (
      <div id={name}>
        <form onSubmit={this.props.handleSubmit}>
          <FormGlobalErrors className="mt-0" errors={this.props.error} />
          <Field
            name="mail"
            component={Select}
            formGroup={<button type="submit" className="btn btn-outline-primary">OK</button>}
          >
            {Object.values(mailing).map((mail) => {
              return (
                <option key={mail.value} value={mail.value}>
                  {mail.subject.length > 30 ? mail.subject.substring(0,30)+'...' : mail.subject}
                </option>
              );
            })
            }
          </Field>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit} />
      </div>
    );
  }
}

export default reduxForm({
  form: name,
  onSubmit: submit,
  onSubmitFail: createOnSubmitFailHandler(name),
})(MailingForm);